import React from "react";
import { Worker } from '@react-pdf-viewer/core';
import { Viewer } from '@react-pdf-viewer/core';
import '@react-pdf-viewer/core/lib/styles/index.css';




const CustomPDFViewer = ({ pdfUrl }) => {

    return (
        <div
            style={{
                border: '1px solid rgba(0, 0, 0, 0.3)',
                width: '100%',
                height: '100%',
            }}
        >
            <div className={`container mx-auto bg-gray-100 transition-opacity duration-700 ${"opacity-100"}`}>
                <div className={`flex flex-col sm:flex-row items-start my-4 px-12 gap-5 transition-all duration-700 ease-in-out ${"opacity-100 translate-y-0"}`}>
                    <iframe
                        src={pdfUrl}
                        title="2F Format PDF"
                        className="w-full h-[1000px] border-2 border-gray-200 rounded-lg"
                        loading="lazy"
                    />
                </div >
            </div >
        </div>

    );
};

export default CustomPDFViewer;
